import _ from  'underscore'
import * as common from 'common'
import darsan from "darsan"
import init from 'init'
import login from "login"

import bootstrap from "bootstrap"
import 'bootstrap-daterangepicker/daterangepicker.css'
import '_lib/bootstrap-treeview/bootstrap-treeview.min.css'

import "@fortawesome/fontawesome-free/css/fontawesome.css"
import "@fortawesome/fontawesome-free/css/brands.css"
import "@fortawesome/fontawesome-free/css/regular.min.css"
import "@fortawesome/fontawesome-free/css/solid.min.css"
import "@fortawesome/fontawesome-free/css/v4-font-face.min.css"

import $ from "jquery"
import "jquery-ui"
import "jquery-ui/ui/widgets/draggable"
import "jquery-ui/ui/widgets/droppable"
import "jquery-ui/ui/widgets/resizable"
import "jquery-ui/ui/widgets/sortable"
import "jquery-ui/ui/widgets/dialog"
// должно идти после Bootstrap, иначе не работает tooltip
import "jquery-ui/ui/widgets/tooltip"

import "jquery-ui/themes/base/theme.css"
import "jquery-ui/themes/base/base.css"

import "select2"
import 'select2/select2.css'
import 'select2/select2-bootstrap.css'
import 'select2/select2_locale_ru.js'

import "../public/css/main.css"
import 'leaflet/dist/leaflet.css'

import {notifyError} from "common"

import { createApp } from "vue"
window.onerror = (message, source, line, column, error) => 
{
    notifyError(message)
}

import { store } from "store"

import Common from "CommonMixin.js"

import App from "App.vue"
import Panel from "common/visual/Panel.vue"
import SearchTable from "common/visual/SearchTable.vue"
import Table from "common/visual/Table.vue"
import Icon from "common/visual/Icon.vue"

import Highcharts from 'highcharts';

Highcharts.setOptions({
  // options here
})

let app = null

////////////////////////////////////////////////////////////////

fetch(API+'/config')
  .then(response => response.json())
  .catch(err => alert("Не могу получить конфигурацию: " + err.stack))
  .then(conf => 
  {
    config = conf
    main()
  })
  .catch(err => alert("Не могу инициализировать конфигурацию: " + err.stack));

//////////////////////////////////////////////


function main()
{
  init.initDarsan(darsan)
  login.init()

  app = createApp(App)

  app.use(store)
  app.config.globalProperties.$store = store
  app.config.globalProperties.$app = app
  
  app.component("Panel", Panel)
  app.component("SearchTable", SearchTable)
  app.component("Table", Table)
  app.component("Icon", Icon)

  app.mixin(Common)

  app.config.ignoredElements = ["font"]
  app.config.compilerOptions.isCustomElement = (tag) => tag == "font"
  app.config.errorHandler = vueError

  if (!config.additional_client_domains) config.additional_client_domains = []  
  
  config.additional_client_domains.forEach(el =>
  {
      el.range = el.range.split("-")
  })

  init.initRadix(store)

  store.commit("setConfig", config)
  app.mount('#app')
  
  // сменим иконку
  $("#favicon").attr("href",`/img/favicon/${config.domain}.ico`);
  
  Highcharts.setOptions({
    lang: {
      shortMonths: ["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек",],
      weekdays: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье" ],
      resetZoom: "1:1",
      resetZoomTitle: "Установить масштаб 1:1",
    },  
  })
  
  // затребовать токен дарсана. Сам по себе тут он нам не нужен, но это вызовет при необходимости первую загрузку 
  // и появится окно логина
  darsan.promiseUserInfo()
    .done( rec => init.initUser(store, rec) )
    .fail(xhr => darsan.err(xhr));
}

function vueError(err, vm, info)
{
  if (!vm) vm = {name: "???"}
  notifyError(vm.name+": "+info+"<br/>"+err)
  console.log(vm.name, err, info)
}

/////////////////////////////

export function getApp() { return app }
